import React, { useEffect } from 'react';

export const useInfiniteScroll = (
  ref: React.RefObject<HTMLElement | null>,
  callback: () => void,
  options: any = DEFAULT_OPTIONS
) => {
  const optionsRef = React.useRef(options);

  useEffect(() => {
    // Only update ref if options changed deeply? or just rely on what is passed.
    // If we use default, it's stable now.
    optionsRef.current = options;
  }, [options]);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback();
      }
    }, optionsRef.current);

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [ref, callback]); // removed options from deps to avoid re-creation loop if unmemoized object passed
};

const DEFAULT_OPTIONS = {
  root: null,
  rootMargin: '200px',
  threshold: 0.1,
};
